import firebase from "firebase";

// Initialize Firebase
const config = {
  apiKey: "AIzaSyCDSbYoSZdOIT7CK-rckGQPYizVLGUuqmc",
  authDomain: "cardiometabolic-sanfer.firebaseapp.com",
  databaseURL: "https://cardiometabolic-sanfer.firebaseio.com",
  projectId: "cardiometabolic-sanfer",
  storageBucket: "cardiometabolic-sanfer.appspot.com",
  messagingSenderId: "908615523368",
  appId: "1:908615523368:web:3bbcb6c3b63dfe2a6de91d",
  measurementId: "G-1E0WDHG6RL"
};

firebase.initializeApp(config);
firebase.auth().languageCode = 'es'
const auth = firebase.auth();
const functions = firebase.functions();

const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();
const githubAuthProvider = new firebase.auth.GithubAuthProvider();
const twitterAuthProvider = new firebase.auth.TwitterAuthProvider();

const database = firebase.firestore();

export {
  database,
  auth,
  functions,
  googleAuthProvider,
  githubAuthProvider,
  facebookAuthProvider,
  twitterAuthProvider
};
